import SiteSelection from 'FeatureModules/Site/Components/Forms/SiteSelection';
import { FieldWrapper } from 'DesignSystem';
import { useField } from 'formik';
import React, { FC } from 'react';
import { IBaseSite } from 'FeatureModules/Site/types/site.types';

interface ISitesAutocompleteWrapperProps {
  name: string;
  disabled?: boolean;
  // Filters the site selection by owner
  filterByOwnerId?: string;
  label?: string;
  helperText?: string;
  required?: boolean;
  'data-testid'?: string;
  onChange?: (selectedSites: IBaseSite[] | undefined) => void;
}

const SitesAutocompleteWrapper: FC<ISitesAutocompleteWrapperProps> = ({
  name,
  label = 'Select site',
  disabled,
  helperText,
  filterByOwnerId,
  required,
  'data-testid': dataTestId,
  onChange,
}) => {
  const [{ value }, { error }, { setValue, setTouched }] = useField<IBaseSite[] | undefined>(name);

  const handleSelectionChange = async (selectedSites: IBaseSite[] | undefined) => {
    await setTouched(true);
    setValue(selectedSites, true);
    onChange?.(selectedSites);
  };

  return (
    <FieldWrapper
      label={label}
      required={required}
      fullWidth
      tooltip={{
        helperText,
        variant: 'INFO',
      }}
    >
      <SiteSelection
        multiple
        viewOption={null}
        data-testid={dataTestId}
        filterByOwnerId={filterByOwnerId}
        defaultValue={value}
        errorMessage={error}
        onSelectionChange={handleSelectionChange}
        disabled={disabled}
      />
    </FieldWrapper>
  );
};

export default SitesAutocompleteWrapper;
